import * as actionTypes from "Application/Store/Actions/UserTypes"

/*****************************************************************
 *  User Reducer
 * ***************************************************************/

const initialState = {
  connected: false,
  expired: false,
  user: {},
  hasLiveAccess: false,
  deniedServices: [/*'showEdition', 'allowEdition'*/],
  bypassAccess: false
}

/**
 * Update State
 * @param {object} state 
 * @param {*} action 
 * @returns 
 */
export const UserReducer = ( state = initialState, action) => {
    switch (action.type) {
      case actionTypes.USER_CONNECTED:
        return {
          ...state,
          connected: true,
          expired: false
        }
        case actionTypes.USER_DISCONNECTED:
          return {
            ...state,
            connected: false,
            expired: false
          }
        case actionTypes.TOKEN_EXPIRED:
          return {
            ...state,
            connected: false,
            expired: true
          }
        case actionTypes.IGNORE_EXPIRED_TOKEN:
          return {
            ...state,
            expired: false
          }
        case actionTypes.ADD_USER_NAME:
          return {
            ...state,
            user: {...state.user, name:action.payload}
          }
        case actionTypes.ADD_DENIED_SERVICE:
          return {
            ...state,
            deniedServices: [...state.deniedServices, action.payload]
          }
        case actionTypes.SET_LIVE_ACCESS:
          return {
            ...state,
            hasLiveAccess: action.payload
          }
        default:
          return state
      }
}